import React, { Component } from "react";
import { Link } from "react-router-dom";
import TimeDiff from "../../helpers/TimeDiff";
import store from "../../store";
import MinNav from "../component/MinNav";

class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      storeState: true
    };

    this.toggleBan = this.toggleBan.bind(this);
    this.onChange = this.onChange.bind(this);
    this.toggleAccessLevel = this.toggleAccessLevel.bind(this);
  }

  toggleAccessLevel(e) {
    let userID = e.target.getAttribute("data-id");
    let acl = parseInt(e.target.getAttribute("data-acl"));
    if (parseInt(store.getState().columnOne.details.acl) !== 2) {
      alert("You are not authorized!");
      return;
    }

    acl = acl === 0 ? 1 : 0;
    fetch(`${this.props.apiROOT}user/acl/${userID}/${acl}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          //eslint-disable-next-line
          this.state.users.map((u, i) => {
            if (u.user_id === userID) {
              //eslint-disable-next-line
              this.state.users[i].acl = acl;
            }
          });
          this.setState({ users: this.state.users });
        }
      });
  }

  onChange(e) {
    this.setState({ storeState: false });
    let searchValues = e.target.value;
    fetch(`${this.props.apiROOT}user/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.users.length > 0) {
          this.setState({ users: data.users });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  toggleBan(e) {
    let userID = e.target.getAttribute("data-id");
    let banStatus = e.target.getAttribute("data-ban-status");
    let acl = parseInt(e.target.getAttribute("data-acl"));
    let action = parseInt(banStatus) === 0 ? "ban" : "stopBan";

    if (acl > parseInt(store.getState().columnOne.details.acl)) return;

    fetch(`${this.props.apiROOT}user/${action}/${userID}`)
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          //eslint-disable-next-line
          this.state.users.map((u, i) => {
            if (u.user_id === userID) {
              let ban_status = parseInt(this.state.users[i].ban_status);
              if (ban_status === 0) {
                //eslint-disable-next-line
                this.state.users[i].ban_status = 1;
              } else {
                //eslint-disable-next-line
                this.state.users[i].ban_status = 0;
              }
            }
          });
          this.setState({ users: this.state.users });
        }
      });
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}user/adminFetchAllUsers`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          users: data.users
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />

        <div style={{ padding: 5 + "px " + 1 + "%" }}>
          <input
            placeholder="Search username..."
            onChange={this.onChange}
            style={{ background: "#f9f9f9", width: 99 + "%" }}
          />
        </div>

        <table className="a-table">
          <thead>
            <tr>
              <td>Username</td>
              <td>Email</td>
              <td>Time Posted</td>
              {parseInt(store.getState().columnOne.details.acl) === 2 && (
                <td>Access Level</td>
              )}
              <td>Ban Status</td>
            </tr>
          </thead>
          <tbody>
            {this.state.users.length > 0 &&
              this.state.users.map(u => (
                <tr key={u.user_id} id={`row${u.user_id}`}>
                  <td style={{ textAlign: "left" }}>
                    <Link
                      to={`/user/${u.username.replace(/ /g, "-")}-${u.user_id}`}
                    >
                      {u.username}{" "}
                    </Link>
                  </td>
                  <td style={{ textAlign: "left" }}>{u.email}</td>
                  <td>
                    <TimeDiff date={u.created_at} />{" "}
                  </td>

                  {parseInt(store.getState().columnOne.details.acl) === 2 && (
                    <td>
                      <button
                        className={`a-acl-${u.acl}`}
                        data-id={u.user_id}
                        data-acl={u.acl}
                        onClick={this.toggleAccessLevel}
                      >
                        {parseInt(u.acl) === 0 && `Member`}
                        {parseInt(u.acl) === 1 && `Admin`}
                        {parseInt(u.acl) === 2 && `Super Admin`}
                      </button>
                    </td>
                  )}

                  <td>
                    {parseInt(u.acl) !== 2 && (
                      <button
                        className={
                          parseInt(u.ban_status) === 0
                            ? `a-table-delete`
                            : `a-table-retrieve`
                        }
                        data-id={u.user_id}
                        data-ban-status={u.ban_status}
                        data-acl={u.acl}
                        onClick={this.toggleBan}
                      >
                        {parseInt(u.ban_status) === 0 ? `Ban` : `Stop Ban`}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default UserTable;
